export default "__VITE_ASSET__DJvLlKh4__"